import React, { useState, useEffect } from 'react'
import BranchIO from '../utils/branch-io'
import SVG from './SVG'

const branchIO: BranchIO = new BranchIO({})

const SocialShare = ({ handleDismiss, pageType, item, image, title, description }) => {
  const [branchURL, setBranchURL] = useState('')
  const [animated, setAnimated] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const desktopUrl = window.location.href
      branchIO.createDeepLink(desktopUrl, title, description, image, (link) => {
        setBranchURL(link)
      })
    }
  }, [])

  const handleClick = () => {
    const iosCopyToClipboard = (el) => {
      const oldContentEditable = el.contentEditable
      const oldReadOnly = el.readOnly
      const range = document.createRange()
      el.contentEditable = true
      el.readOnly = false
      range.selectNodeContents(el)
      const s = window.getSelection()
      s.removeAllRanges()
      s.addRange(range)
      el.setSelectionRange(0, 999999) // A big number, to cover anything that could be inside the element.
      el.contentEditable = oldContentEditable
      el.readOnly = oldReadOnly
      document.execCommand('copy')
    }
    const iOS = () => {
      return (
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
          navigator.platform
        ) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      )
    }
    const copyToClipboard = () => {
      navigator.clipboard.writeText((document.getElementById('branchURLId') as HTMLInputElement).value)
    }
    iOS() ? iosCopyToClipboard(document.getElementById('branchURLId')) : copyToClipboard()
    setAnimated(true)
    setTimeout(() => {
      setAnimated(false)
    }, 800)
    copyClickedAnalytics()
  }

  const openSharerLink = (shareTo, branchLink, title, imageUrl, slug) => {
    switch (shareTo) {
      case 'Facebook':
        branchIO.OpenFacebookLink(branchLink, title, imageUrl, slug)
        return
      case 'Twitter':
        branchIO.OpenTwitterLink(branchLink, title, imageUrl, slug)
        return
      case 'Pinterest':
        branchIO.OpenPinterestLink(branchLink, title, imageUrl, slug)
    }
  }

  const getAdobeProperties = (shareTo, pageType, item) => {
    let currentType = null
    let pageProperties = {}

    if (typeof window !== 'undefined') {
      const current = (window as any).digitalData
      currentType = current.page.pageInfo.pageType
    }

    switch (pageType) {
      case 'Product':
        pageProperties = {
          pageType: currentType,
          productID: item.upc,
          pageName: item.digital_product_name.toLowerCase(),
          productName: item.digital_product_name.toLowerCase(),
          shareTo
        }
        return pageProperties
      case 'Article':
        pageProperties = {
          pageType: currentType,
          articleID: item.id,
          pageName: item.title,
          shareTo
        }
        return pageProperties
      case 'Collage':
        pageProperties = {
          pageType: currentType,
          collageID: item.id,
          pageName: item.title,
          categoryID: item.category,
          shareTo
        }
        return pageProperties
      case 'Reward':
        pageProperties = {
          pageType: currentType,
          pageName: title,
          shareTo
        }
        return pageProperties
      case 'Event':
        pageProperties = {
          pageType: currentType,
          eventID: item.id,
          pageName: item.event_name,
          shareTo
        }
        return pageProperties
    }
  }

  const shareToSocialMedia = (shareTo, pageType, item) => {
    const adobeProperties = getAdobeProperties(shareTo.toLowerCase(), pageType, item);
    (window as any)._satellite.track('share-clicked', adobeProperties)
    openSharerLink(shareTo, branchURL, title, image, item.slug)
  }

  const copyClickedAnalytics = () => {
    const adobeProperties = getAdobeProperties('Copy Link', pageType, item);
    (window as any)._satellite.track('copy-share-clicked', adobeProperties)
  }

  return (
    <div className="social-share">
      <section>
        <p>Share</p>
        <div className="social-share__icons">
          <div className="social-share__icon">
            <button onClick={(e) => shareToSocialMedia('Facebook', pageType, item)}>
              <SVG name="facebook--icon" label="facebook" size="xl" />
            </button>
          </div>
          <div className="social-share__icon">
            <button onClick={() => shareToSocialMedia('Twitter', pageType, item)}>
              <SVG name="twitter--icon" label="twitter" size="xl" />
            </button>
          </div>
          <div className="social-share__icon">
            <button onClick={() => shareToSocialMedia('Pinterest', pageType, item)}>
              <SVG name="pinterest--icon" label="pinterest" size="xl" />
            </button>
          </div>
        </div>
        <label htmlFor="branchURLId">Page link</label>
        <div className="form-wrap">
          <div className="input-wrap">
            <input
              readOnly={false}
              contentEditable={true}
              type="text"
              id="branchURLId"
              defaultValue={branchURL + '?~channel=URL&~feature=websdk&~campaign=' + item.slug}
              onClick={(e) => e.preventDefault()}
            />
            <a data-testid={'linkElement'} onClick={handleClick} className={`${!animated ? 'icon-copy' : 'icon-copy-check'} ion-button`}>
              <SVG name={`${!animated ? 'icon-copy' : 'icon-copy-check'}`} label="icon-cpoy" />
            </a>
          </div>
        </div>
        <button className="btn__primary" onClick={handleDismiss}>
          CLOSE
        </button>
      </section>
    </div>
  )
}

export default SocialShare
